import React from 'react'


class Cantidad extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cantidad: 1
     };


  }


  onClick(event) {
    //console.log(event.target.name)
    if((event.target.id === 'suma' || event.currentTarget.id === 'detalleCantidad') && !this.props.esMitad){
      this.setState((state) => ({
        cantidad: state.cantidad + 1
      }));
    }else if(event.target.id === 'resta'){

      if(this.state.cantidad > 1){
        this.setState((state) => ({
          cantidad: state.cantidad - 1
        }));
      }
    }

  }

componentDidUpdate(prevProps, prevState){

  if (this.props.producto !== prevProps.producto) {
    // pone en 1 la cantidad al cambiar de categoria
    this.props.cantidadSeleccionada(1)
    this.setState({ cantidad: 1 })
  }

  if (this.props.esMitad !== prevProps.esMitad){
    // si es pizza en mitad no se puede agregar mas cantidades
    if(this.props.esMitad) {
      this.props.cantidadSeleccionada(1)
      this.setState({ cantidad: 1 })
    }
  }


  if (this.state.cantidad !== prevState.cantidad) {

  this.props.cantidadSeleccionada(this.state.cantidad)
  //console.log("cant seleccionada", this.state.cantidad, "prevState", prevState.cantidad)
  }
}



  render() {

    // si hay adicionales sumarlos
    var adicionales = 0;

    function sumaAdicionales(value, index, array) {
      adicionales += Number(value.precio);
      //console.log(adicionales)
    }

    if(this.props.adicionales.length > 0){
      this.props.adicionales.forEach(sumaAdicionales);
    }

    var total = (Number(this.props.producto.precio) + adicionales) * Number(this.state.cantidad);

    if(isNaN(total)) return ""

    return (
      <div className="d-flex flex-row rounded border border-success bg-light p-1 mx-1">
        <div className="align-middle my-auto mx-auto"><span id="detalleCantidad" className="h5" onClick={event => this.onClick(event)}>Cantidad = <span>{this.state.cantidad} x $ {total}</span></span></div>

          {this.state.cantidad > 1 &&
              <div className="align-middle"><i id="resta" className="fas fa-minus-circle fa-3x text-danger" onClick={event => this.onClick(event)}></i></div>
                }

        {!this.props.esMitad &&
              <div className="align-middle mr-2"><i id="suma" className="fas fa-plus-circle fa-3x text-success" onClick={event => this.onClick(event)}></i></div>
                }


      </div>
    )
  }
}

export default Cantidad
